import React from 'react';
import { Box, Button, Modal, Backdrop, Fade } from '@mui/material';

import { useBookingsContext } from '../../contexts/BookingsContext';
import ManageReport from '../../pages/ManageReport'

import { useManageReportModalStyles } from './styles';

const ManageReportModal = () => {
  const { isManageReportModalOpen, setIsManageReportModalOpen } = useBookingsContext();
  const styles = useManageReportModalStyles();

  return (
    <Modal
      open={isManageReportModalOpen}
      onClose={() => setIsManageReportModalOpen(false)}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 300,
        },
      }}>
      <Fade in={isManageReportModalOpen}>
        <Box 
          sx={styles.modal}
          >

          <Button 
            sx={styles.close}
            onClick={() => { setIsManageReportModalOpen(false) }}
            >
            Close
          </Button>
          <ManageReport />

        </Box>
      </Fade>
    </Modal>
  )
};

export default ManageReportModal;
